/**
 * Formats postal code number
 * 00000000 to 00000-000
 * @param {number|string} postalCode - Postal code to be formats
 * @returns {string} - Formatted postal code
 */
function beautifyPostalCode(postalCode) {
  return String(postalCode).replace(/(\d{5})(\d{3})$/, '$1-$2');
}

/**
 * Adds zero to incomplete postal codes until it reaches the length of 8.
 * If the length of the postal code is already 8, nothing is added.
 * @param {string} portalCode - Postal code to be formatted
 * @returns {string} - Formatted postal code
 */
function postalCodeWithZero(postalCode) {
  return unformatPostalCode(postalCode).padStart(8, "0");
}

/**
 * if the postal code is formatted, removes it by returning only numbers
 * 00.000-000 or 00000-000 to 00000000
 * @param {String} postalCode - Formatted postal code
 * @returns
 */
function unformatPostalCode(postalCode) {
  return String(postalCode).replace(/\D+/g, '');
}

export {
  beautifyPostalCode,
  postalCodeWithZero,
  unformatPostalCode
}
